import {
  InfinityOption,
  Retrofit,
  RetrofitConfiguration,
  RetrofitListItem,
  RetrofitRecommendation,
  RetrofitStatus,
  RetrofitSystem,
} from '../../models/retrofit.model'
import {
  InfinityOptionDto,
  RetrofitConfigurationDto,
  RetrofitDto,
  RetrofitListItemDto as RetrofitFarmListDto,
  RetrofitRecommendationDto,
  RetrofitSystemDto,
} from '../dto/retrofit.dto'

export const retrofitDtoToModelTransformer = ({ configuration, retrofitRecommendations, status, system, infinityOption }: RetrofitDto): Retrofit => ({
  status: status as RetrofitStatus,
  system: system ? retrofitSystemDtoToModelTransformer(system) : undefined,
  configuration: configuration ? retrotfitConfigurationDtoToModelTransformer(configuration) : undefined,
  retrofitRecommendations: retrofitRecommendations?.map(recommendation => retrofitRecommendationDtoToModelTransformer(recommendation)) ?? [],
  infinityOption: infinityOption ? retrofitInfityOptionDtoToModelTransformer(infinityOption) : undefined,
})

const retrofitSystemDtoToModelTransformer = (values: RetrofitSystemDto): RetrofitSystem => {
  return {
    serialnumber: values.serialno,
    productName: values.productName,
  }
}

const retrotfitConfigurationDtoToModelTransformer = (values: RetrofitConfigurationDto): RetrofitConfiguration => {
  return {
    currentBatteryCount: values?.currentBatteryCount ?? 0,
    capacity: values?.capacity ?? 0,
    power: values?.power ?? 0,
  }
}

const retrofitRecommendationDtoToModelTransformer = (values: RetrofitRecommendationDto): RetrofitRecommendation => {
  return {
    type: values.type,
    maxBatteryCount: values.maxBatteryCount,
    addableBatteryCount: values.addableBatteryCount,
    numberExternalCabinets: values.numExternalCabinets,
    changeBatteryIndex: values.changeBatteryIndex,
    capacity: values.capacity,
    power: values.power,
    info: values.info,
    expiresAt: values.expiresAt,
    cabinetDimension: values.cabinetDimension,
  }
}

const retrofitInfityOptionDtoToModelTransformer = (values: InfinityOptionDto): InfinityOption => {
  return {
    numberModules: values.numModules,
    capacity: values.capacity,
    power: values.power,
    expiresAt: values.expiresAt,
  }
}

export const retrofitListItemDtoToModelTransformer = (values: RetrofitFarmListDto): RetrofitListItem => {
  return {
    serialnumber: values.serialno,
    expiresAt: values.expiresAt,
  }
}
